import config from '../../../../config'

import {
    ADD_GROUP_MONITORING,
    REMOVE_GROUP_MONITORING,
    INITIALIZE_GROUP_MONITORING_DIALOG,
    INITIALIZE_GROUP_MONITORING_REQUEST,
    GROUP_MONITORING_DATA_REQUEST,
    UPDATE_GROUP_MONITORING_REQUEST,
} from './constants'

export const addGroupMonitoring = () => ({
    type: ADD_GROUP_MONITORING,
})

export const removeGroupMonitoring = () => ({
    type: REMOVE_GROUP_MONITORING,
})

export const initializeGroupMonitoringDialog = () => ({
    type: INITIALIZE_GROUP_MONITORING_DIALOG,
})

export const initializeGroupMonitoringRequest = (groupIdentifier, sessionId, isMonitored) => ({
    type: INITIALIZE_GROUP_MONITORING_REQUEST,
    payload: {
        ...config.api.monitoring.initialGroupMonitoring,
        qs: { groupId: groupIdentifier },
        data: { groupIdentifier },
        formData: `isMonitored=${encodeURIComponent(isMonitored)}`,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            accept: 'application/json',
            sid: sessionId,
        },
    },
})

export const updateGroupMonitoringRequest = (groupIdentifier, sessionId, queryId, formData, monitoringData = {}) => ({
    type: UPDATE_GROUP_MONITORING_REQUEST,
    payload: {
        uri: `${config.api.monitoring.groupMonitoringNotifications.uri}${queryId}`,
        method: config.api.monitoring.groupMonitoringNotifications.method,
        data: { groupIdentifier, monitoringData },
        formData,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            accept: 'text/plain',
            sid: sessionId,
        },
    },
})

export const groupMonitoringDataRequest = (groupIdentifier, sessionId, queryId) => ({
    type: GROUP_MONITORING_DATA_REQUEST,
    payload: {
        uri: `${config.api.monitoring.groupMonitoringData.uri}${queryId}`,
        data: { groupIdentifier },
        headers: {
            sid: sessionId,
        },
    },
})
